import styled from 'styled-components'

export const Container = styled.div`
  margin: 20px 30px 0px;
`
